import { isActionsByStavName } from "./isActionsByStavName";

export const isRowSelectable = dataRow =>
  !(dataRow.zdroj.exkluzivita && dataRow.kolize) &&
  isActionsByStavName(dataRow);
